/**
 * Z-Index Design Tokens
 * Style guide §5.4 — five-layer stack
 */

export const zIndex = {
  base: 1,
  dropdown: 10,
  sticky: 50,
  header: 100,
  modal: 200,
  toast: 300,
  tooltip: 400,
} as const;

export type ZIndexToken = typeof zIndex;
